import { styled, keyframes, Box, createGlobalStyle } from '@withjoy/joykit';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FadeInWrapper = styled(Box)`
  animation: ${fadeIn} 0.6s ease-in-out;
`;

// On mobile the enclosing DialogV2 stretches to 100% viewport height with square
// top corners. When we render HoneymoonFundSuccess inside, we want the modal to
// behave as a bottom sheet: hug its content height, anchor to the bottom, and
// round the top corners. We target the ancestor modal via `:has()` so we can
// override JoyKit's Modal styles without forking the component.
// Applies to both AddCashFundDialog and EditCashFundDialog (both use DialogV2).
export const HoneymoonBottomSheetStyle = createGlobalStyle`
  @media (max-width: 767px) {
    /* ContentContainer — pin the sheet to the bottom of the viewport */
    div:has(> div > section:has([data-honeymoon-success-marker="true"])) {
      align-items: flex-end;
    }
    /* Content <section> — the actual dialog panel (DialogV2 id'd root) */
    section:has([data-honeymoon-success-marker="true"]) {
      min-height: auto !important;
      height: auto !important;
      border-radius: 12px 12px 0 0 !important;
    }
    /* AddCashFundDialog wraps content in an inner Flex with its own height/radius */
    section:has([data-honeymoon-success-marker="true"]) > div:has([data-honeymoon-success-marker="true"]) {
      height: auto !important;
      min-height: auto !important;
      border-radius: 12px 12px 0 0 !important;
    }
  }
`;

export const StyledBanner = styled(Box)`
  background-color: ${props => props.theme.colors.positive2};
  border-radius: 999px;
  padding: 6px 16px;
  margin-bottom: 24px;
`;

export const StyledHeroImage = styled.img`
  width: 100%;
  max-width: 480px;
  height: 220px;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
`;
